// extracted by mini-css-extract-plugin
module.exports = {"App":"reset-password_App__1WVm-","Card":"reset-password_Card__1M1zK"};